/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderItemCompany } from './order_item_company'
import type { OrderItemContact } from './order_item_contact'
/**
 * Данные партнёра
 */
export type OrderItemPartner = {
  /**
   * Тип партнёра
   */
  type: OrderItemPartner.type
  /**
   * Компания (юр. лицо). Обязательно при type=Legal, не указывается при type=Individual
   */
  company?: OrderItemCompany
  /**
   * Контакт (физ. лицо). Обязательно при любом значении type
   */
  contact: OrderItemContact
}
export namespace OrderItemPartner {
  /**
   * Тип партнёра
   */
  export enum type {
    LEGAL = 'legal',
    INDIVIDUAL = 'individual'
  }
}
